import type { RouterEntity } from "../../../domain/types/router";
import { RouterEntitySchema } from "../../../domain/types/router";
import type { CompanyRouterRepository } from "../../../domain/repositories/company/company-router-repository";
import { companyRouterApiService } from "../../api/company/company-router-api-service";

export class CompanyRouterRepositoryImpl implements CompanyRouterRepository {
  async getRouters(companyId: number): Promise<RouterEntity[]> {
    const response = await companyRouterApiService.getRouters(companyId);

    if (response.data) {
      return response.data.map(router => RouterEntitySchema.parse(router));
    }

    throw new Error(response.errorMsg || "라우터 가져오기 실패.");
  }
}